import React from 'react';

import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

export default function AnimatedMulti(props) {
  
  
  return (
    <Select
      placeholder="Search..."
      closeMenuOnSelect={false}
      components={animatedComponents}
      value={props.selected}
      onChange={(e) => {
        props.handleMultipleInputChange(e, props.i_index, props.inner_index)
      }}
      isMulti
      options={props.option}
    />
  );
}